import React, {useEffect, useState} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import { 
  apollo_billing_report,
} from "../../atom/Apollo_links";
import {BillingReport} from "../../pages/INVOICE/InVoiceModel";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {optionsZeusDeliveryShortType} from "../../common/Apollo_CommonConst";
// メッセージ定義
import {
  GetMessage,
  UI_INVOICE_MENU_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

/*
    確定請求金額メニューリスト表示
 */
const ApolloInVoiceMenuList = (props: {accountId: string, year: string, month: string, billingType: number}) => {
  const {accountId, year, month, billingType} = props;
  const [rows, setRows] = useState<BillingReport[]>([]);
  const {data, setmsg} = React.useContext(ApolloMessage);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();
  // Zeus配信種別
  const zeusDeliveryShortTypeList = optionsZeusDeliveryShortType.map((v) => {
    return v.label;
  })
  const zeusDeliveryType = zeusDeliveryShortTypeList.join("/");
  
  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    const url = apollo_billing_report + "/" + accountId + "/" + year + "/" + month + "/" + billingType;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        setRows(response.data.result);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_INVOICE_MENU_LIST,"E","0"),
            loading: false
          }
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_INVOICE_MENU_LIST,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [year, month, billingType]);

  // 画面表示
  return (
    <div>
      <Table width={"100%"} padding={"none"}>
        <TableBody>
          {rows && rows.map((row) => (
            <TableRow key={row.advertiserId} hover={false}>
              <TableCell align="left" width={"5%"} style={{borderBottom:"none"}}></TableCell>
              <TableCell align="left" width={"19%"} style={{borderBottom:"none"}}></TableCell>
              <TableCell align="left" width={"19%"} style={{borderBottom:"none"}}></TableCell>
              <TableCell align="left" width={"14%"} style={{borderBottom:"none"}}>{row.menuName}</TableCell>
              <TableCell align="left" width={"19%"} style={{borderBottom:"none"}}>{row.menuId === 1 ? zeusDeliveryType : row.campaignKindName ? row.campaignKindName : "-"}</TableCell>
              <TableCell align="right" width={"12%"} style={{borderBottom:"none"}}>
                {billingType === 1 ?
                  "￥" + row.platformBudget1Amount.toLocaleString()
                :
                  ""
                }
              </TableCell>
              <TableCell align="right" width={"12%"} style={{borderBottom:"none"}}>￥{row.price.toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
export default ApolloInVoiceMenuList;
